/* GASSISA
=========================================================================================
* Descripción: Grupo de menú del sistema
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Recibe estado del padre
*      3       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Orden configurable de páginas
*      4       | 19/06/2026 | Lic. José Luis Aragón Cervantes  | Se ajustan colores sobre theme
* ---------------------------------------------------------------------------------------
*/

import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Fragment } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SizeSoftXMenuItem from "./SizeSoftXMenuItem";
import { menuPaginaIcons } from "../../settings/menuModel";
import { useLayout } from "../../context/System/LayoutContext";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";

export default function SizeSoftXMenuGroup({ groupKey, icon, name, clavesPaginas, isOpen, onToggle }) {
    const { clavePaginaActual } = useLayout();
    const { theme } = useConfiguracion();
    const sortPaginas = (a, b) => {
        const pageA = clavesPaginas[a] ?? {};
        const pageB = clavesPaginas[b] ?? {};
        const orderA = pageA.orden != null ? Number(pageA.orden) : Number.MAX_SAFE_INTEGER;
        const orderB = pageB.orden != null ? Number(pageB.orden) : Number.MAX_SAFE_INTEGER;

        if (orderA !== orderB) return orderA - orderB;
        return (pageA.nombre ?? a).localeCompare(pageB.nombre ?? b);
    };

    const sColorFuentes = theme?.palette?.kyngblue?.contrastText;

    return (
        <Fragment>
            <ListItem disablePadding>
                <ListItemButton
                    onClick={onToggle}
                    sx={{
                        width: "100%",
                        mx: 0,
                        my: 0.35,
                        px: 1.25,
                        minHeight: 44,
                        boxSizing: "border-box",
                        borderRadius: "6px",
                        backgroundColor: isOpen ? "rgba(255,255,255,0.20)" : "rgba(255,255,255,0.10)",
                        boxShadow: isOpen ? "inset 0 0 0 1px rgba(255,255,255,0.32)" : "inset 0 0 0 1px rgba(255,255,255,0.18)",
                        "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.24)",
                            boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.36)",
                        },
                    }}
                >
                    <ListItemIcon sx={{ minWidth: "30px", color: "white", fontWeight: 700 }}>{icon}</ListItemIcon>
                    <ListItemText
                        primary={name}
                        sx={{
                            minWidth: 0,
                            mr: 0.5,
                            "& .MuiListItemText-primary": {
                                fontWeight: 700,
                                fontSize: "1rem", 
                                color: sColorFuentes,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                        }}
                    />
                    {isOpen ? <ExpandLess sx={{ color: sColorFuentes }} /> : <ExpandMore sx={{ color: sColorFuentes }} />}
                </ListItemButton>
            </ListItem>
            <Collapse in={isOpen}>
                <List sx={{ width: "100%", boxSizing: "border-box", py: 0.25 }}>
                    {Object.keys(clavesPaginas)
                        .filter((clave_pagina) => clavesPaginas[clave_pagina].mostrar)
                        .sort(sortPaginas)
                        .map((clave_pagina) => (
                            <SizeSoftXMenuItem
                                key={clave_pagina}
                                icon={menuPaginaIcons[clave_pagina]}
                                route={clavesPaginas[clave_pagina].path}
                                clavePagina={clave_pagina}
                                disabled={clavesPaginas[clave_pagina].status}
                                hotkey={clavesPaginas[clave_pagina].hotkey}
                            >
                                {clavesPaginas[clave_pagina].nombre}
                            </SizeSoftXMenuItem>
                        ))}
                </List>
            </Collapse>
        </Fragment>
    );
}
